import { SocialShareButtons, ShareImageButton, SharePopover } from './share';
import type { ShareCardData } from '@/lib/share-card-renderer';

interface ShareExportToolbarProps {
  title: string;
  subtitle?: string;
  url?: string;
  compact?: boolean;
  cardData?: Partial<ShareCardData>;
  /** When true, desktop drops outer border container (dock provides surface) */
  bare?: boolean;
}

export function ShareExportToolbar({
  title,
  subtitle,
  url,
  compact,
  cardData,
  bare,
}: ShareExportToolbarProps) {
  return (
    <SharePopover compact={compact} bare={bare}>
      <SocialShareButtons title={title} subtitle={subtitle} url={url} />
      <div className="h-5 w-px bg-border-subtle mx-1" aria-hidden="true" />
      <ShareImageButton title={title} subtitle={subtitle} cardData={cardData} />
    </SharePopover>
  );
}
